
  import {
    Component,
    Model,
    Prop,
    Vue,
    Watch
  } from "vue-property-decorator";
  import Dialog from '@/components/dialog.vue';
  import {
    pca
  } from '@/utils/pca';

  @Component({
    name: 'logistics-select',
    components: {
      'slz-dialog': Dialog
    }
  })
  export default class LogisticsSelect extends Vue {
    private showDialog = false;
    private areaData: any = null;
    private areaNum: any = [];
    private nums: any = [];
    private activeProvice:any = [];
    private activeCity:any = [];
    private activeArea:any = [];
    private currentCityList: any = null;
    private currentCounty: any = null;
    private selectCountObj: any = {};
    private disableCountObj: any = {};
    private judgeCheck: any = {};
    private judgeDisable: any = {};
    private isReverse = false;
    private newSelect:any = []
    private tiledlist:any = []

    @Model('change') isShow!: boolean;
    @Prop({}) private selectData!: any;
    @Prop({}) private disableDate: any;
    @Watch('isShow')
    private onChangeShow(val: boolean) {
      this.showDialog = val;
    }

    private _Init() {
      this.getArea()
    }

    /**
     * 分析传入地址
     */
    private analysisPropData() {
      if (!this.newSelect) return
      for (const i in this.areaData) {
        const provinces = Object.getOwnPropertyNames(this.areaData[i])
        for (let j = 0; j < this.newSelect.length; j++) {
          if (provinces.indexOf(this.newSelect[j][0]) !== -1) {
            this.newSelect[j].unshift(i)
          }
        }
      }
      for (let i = 0; i < this.newSelect.length; i++) {
        const val: any = this.newSelect[i]
        if (!this.selectCountObj[val[1] + val[2]]) {
          if (val.length === 2) {
            for (const p in this.areaData[val[0]][val[1]]) {
              if (!this.selectCountObj[val[1] + p]) {
                this.$set(this.selectCountObj, val[1] + p, {
                  area: val[0],
                  province: val[1],
                  city: p,
                  value: this.areaData[val[0]][val[1]][p]||[]
                })
              }
            }
          }
          if (val.length === 3) {
            if (!this.selectCountObj[val[1] + val[2]]) {
              this.$set(this.selectCountObj, val[1] + val[2], {
                area: val[0],
                province: val[1],
                city: val[2],
                value: this.areaData[val[0]][val[1]][val[2]]||[]
              })
            }
          }
          if (val.length === 4) {
            this.$set(this.selectCountObj, val[1] + val[2], {
              area: val[0],
              province: val[1],
              city: val[2],
              value: val[3]?[val[3]]:[]
            })
          }
        } else {
          this.selectCountObj[val[1] + val[2]].value.push(val[3])
        }

      }
      this.judgeCityCheckAll()
    }


    /**
     * 获取地址数据
     */
    private getArea() {
      const list: any = []
      let index = 0
      this.areaNum = []
      this.areaData = pca
      // for(let item in this.areaData){
      //   for(let item2 in this.areaData[item]){
      //     for(let item3 in this.areaData[item][item2]){
      //       for(let item4 of this.areaData[item][item2][item3]){
      //         this.tiledlist.push(item+'-'+item2+'-'+item3+'-'+item4)
      //       }
      //     }
      //   }
      // }
      this.newSelect = this.selectData
      // .filter(v=>{
      //   return this.tiledlist.some(x=>x.indexOf(v.join('-')>0))
      // })
      // console.log(this.newSelect)
      for (const i in pca) {

        this.areaNum.push(Object.getOwnPropertyNames(pca[i]).length - 1)
        list.push([])
        for (const j in pca[i]) {
          list[index].push(Object.getOwnPropertyNames(pca[i][j]).length - 1)
        }
        index++
      }
      this.nums = list
      this.analysisPropData()
      // this.analysisdisableData()
    }

    //地区是否禁用
    private disregional(key){
      let arr = Object.keys(this.areaData[key])
      return arr.every(v=>{
        return this.disableDate.some(x=>x==v)
      })
    }

    //是否禁用
    private needDisable(key,lastkey){
      // 
      let all = this.disableDate.map(v=>{
        if(Array.isArray(v)&&Array.isArray(v[0])){
          return v.map(x=>x.join('-'))
        }else{
          return v.join('-')
        }
      }).flat()
      return all.some(v=>v==lastkey+'-'+key)


      // let havekey:boolean, havelastkey:boolean
      // if(lastkey){
      //   havelastkey = this.disableDate.some(v=>{
      //     //没有v[v.length-2] 说明最低级是省份
      //     return v[v.length-2]?v[v.length-2]==lastkey:true
      //   })
      // }else{
      //   havelastkey = true
      // }
      // havekey = this.disableDate.some(v=>{
      //   return v[v.length-1]==key
      // })
      // return havekey&&havelastkey
    }

    /**
     * 选择七大地区
     */
    private handleCheckAllArea(e: any, key: string, val: any) {
      this.activeArea = key
      // console.log(e)
      if (e) {
        const data: any = JSON.parse(JSON.stringify(val))
        
        // console.log(this.disableDate,'e')
        for (const i in data) {
          if(this.disableDate&&this.disableDate.length){
            for(const v of this.disableDate){
              //不被禁用的省才勾选
              // console.log(v,i)
              if(v.length==1 && v[0]==i){
                // console.log(i,v,'被禁用的',false)
                this.changeProvinceSelect(false, key, i, data[i])
                break
              }
              this.changeProvinceSelect(e, key, i, data[i])
            }
          }else{
            this.changeProvinceSelect(e, key, i, data[i])
          }
        }
      } else {
        for (const i in val) {
          this.changeProvinceSelect(e, key, i, val[i])
        }
      }
    }

    /**
     * 空函数
     */
    private handleEmpty() {
      return
    }

    /**
     * 清空点击事件
     */
    private clearClickEvent() {
      this.activeProvice = ''
      this.currentCityList = null
      this.activeCity = ''
      this.currentCounty = null
    }

    /**
     * 点击省
     */
    private clickArrow(area: any, data: any, index: string) {
      this.activeArea = area
      this.currentCityList = data
      this.activeProvice = index
      this.activeCity = ''
      this.currentCounty = null
    }

    /**
     * 点击市
     */
    private clickCity(data: any, ckey: string,pkey:any,key:any) {
      // console.log(data,555,index,666)
      this.currentCounty = data
      this.activeCity = ckey
    }

    /**
     * 选择区级
     */
    private handleSelectCounty(areaName: string, gprentName: string, parentName: string, childName: string) {
      /*
      areaName:七大地区
      gprentName:省
      parentName:市
      childName:区县

      所有已选中的市级 所在的关系链
      this.selectCountObj:{
        area
      }
      */
      let list: any = []
      let currentVal: any = {}
      const currentKey = gprentName + parentName
      //  console.log(this.selectCountObj[currentKey])
      // console.log(this.selectCountObj[currentKey],this.selectCountObj[currentKey].value,222)
      if (this.selectCountObj[currentKey] && this.selectCountObj[currentKey].value && this.selectCountObj[currentKey].value.length) {
        //当前区县的集合
        list = JSON.parse(JSON.stringify(this.selectCountObj[currentKey].value))
        //当前地区关系链
        currentVal = this.selectCountObj[currentKey]
      }

      const index = list.indexOf(childName)
      let isCurrCounty = false
      // console.log(this.selectCountObj[currentKey])
      //是属于区县
      if (this.selectCountObj[currentKey] && (areaName === currentVal.area && gprentName == currentVal.province &&
          parentName === currentVal.city)) {
        isCurrCounty = true
      }

      if (index > -1 && isCurrCounty) {
        // console.log(index,isCurrCounty)
        list.splice(index, 1)
      } else {
        list.push(childName)
      }

      this.$set(this.selectCountObj, currentKey, {
        value: list,
        city: parentName,
        province: gprentName,
        area: areaName
      })

      if (this.selectCountObj[currentKey] && this.selectCountObj[currentKey].value && !this.selectCountObj[currentKey]
        .value.length) {
        delete this.selectCountObj[currentKey]
      }

      this.judgeCityCheckAll()
    }

    /**
     * 判断城市是否全选
     */
    private judgeCityCheckAll() {
      this.judgeCheck = {}
      
      for (const i in this.selectCountObj) {
        const val: any = this.selectCountObj[i]
        let fullLen = 0
        // console.log(this.areaData,this.selectCountObj,999)
        if(this.areaData[val.area][val.province]&&this.areaData[val.area][val.province][val.city]){
          fullLen = this.areaData[val.area][val.province][val.city].length
        }
        // console.log(fullLen)
        if (!this.judgeCheck[val.area]) {
          this.$set(this.judgeCheck, val.area, {
            indeterminate: true,
            checkAll: false,
            value: [val.province]
          })
        } else {
          if (this.judgeCheck[val.area].value.indexOf(val.province) === -1) {
            this.judgeCheck[val.area].value.push(val.province)
          }
        }
        if (!this.judgeCheck[val.area][val.province]) {
          this.$set(this.judgeCheck[val.area], val.province, {
            indeterminate: true,
            checkAll: false,
            value: [val.city]
          })
        } else {
          if (this.judgeCheck[val.area][val.province].value.indexOf(val.city) === -1) {
            this.judgeCheck[val.area][val.province].value.push(val.city)
          }
        }
        if (!this.judgeCheck[val.area][val.province][val.city]) {
          // console.log(Object.keys(this.areaData[val.area][val.province]).map(v=>val.area+'-'+v),chooseCitys)
          this.$set(this.judgeCheck[val.area][val.province], val.city, {
            indeterminate: val.value.length && val.value.length !== fullLen,
            checkAll: fullLen === val.value.length,
            value: val.value
          })
        } else {
          this.judgeCheck[val.area][val.province][val.city] = {
            indeterminate: val.value.length && val.value.length !== fullLen ? true : false,
            checkAll: fullLen === val.value.length ? true : false,
            value: val.value
          }
        }
      }

      // 判断省是否全选
      for (const i in this.judgeCheck) {
        for (let p = 0; p < this.judgeCheck[i].value.length; p++) {
          const province = this.judgeCheck[i].value[p]
          let isCheckAll = 0
          let isIndeterminateAll = 0
          for (let c = 0; c < this.judgeCheck[i][province].value.length; c++) {
            const city = this.judgeCheck[i][province].value[c]
            if (this.judgeCheck[i][province][city].checkAll) {
              isCheckAll += 1
            }
            if (this.judgeCheck[i][province][city].indeterminate) {
              isIndeterminateAll += 1
            }
          }
          const allLen = Object.getOwnPropertyNames(this.areaData[i][province]).length - 1
          this.judgeCheck[i][province].checkAll = isCheckAll === allLen
          this.judgeCheck[i][province].indeterminate = (isCheckAll !== allLen) && (isCheckAll || isIndeterminateAll) ?
            true : false
        }
      }

      // 判断区域是否全选
      for (const i in this.judgeCheck) {
        let isAreaCheckAll = 0
        let isIndeterminateAll = 0
        for (let p = 0; p < this.judgeCheck[i].value.length; p++) {
          const province = this.judgeCheck[i].value[p]
          if (this.judgeCheck[i][province].checkAll) {
            isAreaCheckAll = isAreaCheckAll + 1
          }
          if (this.judgeCheck[i][province].indeterminate) {
            isIndeterminateAll += 1
          }
        }
        const allL = Object.getOwnPropertyNames(this.areaData[i]).length - 1
        this.judgeCheck[i].checkAll = isAreaCheckAll === allL
        this.judgeCheck[i].indeterminate = (isAreaCheckAll !== allL) && (isAreaCheckAll || isIndeterminateAll) ?
          true : false
      }
    }
    /**
     * 改变城市选择
     */
    private changeCitySelect(e: any, area: string, pkey: string, key: string, val: any, type ? : string) {
      if (type === 'click') {
        this.activeCity = key
        this.currentCounty = val
      }
      // console.log(area,pkey,key,val)
      // let boo = this.judgeCheck[area] && this.judgeCheck[area][pkey] && this.judgeCheck[area][pkey][key] && this.judgeCheck[area][pkey][key].checkAll
      // console.log(boo)
      // console.log(val)
      if (e) {
        let data = JSON.parse(JSON.stringify(val))
        // console.log(data,'data',this.disableDate)
        this.disableDate.map(v=>{
          data = data.filter(x=>{
            return x!=v[v.length-1]
          })
        })
        this.$set(this.selectCountObj, pkey + key, {
          value: data,
          city: key,
          province: pkey,
          area: area
        })
        // console.log(data,key,pkey,area)
      } else {
        this.$set(this.selectCountObj, pkey + key, {
          value: [],
          city: key,
          province: pkey,
          area: area
        })
      }
      if (type !== 'all') {
        this.judgeCityCheckAll()
      }
    }

    /**
     * 改变省份选择
     */
    private changeProvinceSelect(e: any, key: string, pkey: string, val: any) {
      this.activeArea = key
      this.activeProvice = pkey
      this.currentCityList = val
      if (e) {
        const data: any = JSON.parse(JSON.stringify(val))
        // console.log(pkey)
        for (const i in data) {
          if(this.disableDate&&this.disableDate.length){
            for(const v of this.disableDate){
              //不被禁用的省才勾选
              // console.log(v,i)
              if(v.length==2 && v[0]==pkey && v[1]==i){
                // console.log(i,v,'被禁用的',false)
                this.changeCitySelect(false, key, pkey, i, data[i], 'all')
                break
              }
              this.changeCitySelect(e, key, pkey, i, data[i], 'all')
            }
          }else{
            this.changeCitySelect(e, key, pkey, i, data[i], 'all')
          }
        }
      } else {
        for (const i in val) {
          this.changeCitySelect(e, key, pkey, i, val, 'all')
        }
      }
      this.judgeCityCheckAll()
    }

    /**
     * 获取数据
     */
    private confirm() {
      let list: any = []
      for (const area in this.judgeCheck) {
        const areaVal: any = this.judgeCheck[area]
        for (let i = 0; i < areaVal.value.length; i++) {
          const provinceVal: any = areaVal[areaVal.value[i]]
          if (provinceVal.checkAll) {
            list.push([areaVal.value[i]])
            continue
          }
          for (let j = 0; j < provinceVal.value.length; j++) {
            const cityVal: any = provinceVal[provinceVal.value[j]]
            if (cityVal.checkAll) {
              list.push([areaVal.value[i], provinceVal.value[j]])
              continue
            }
            for (let k = 0; k < cityVal.value.length; k++) {
              list.push([areaVal.value[i], provinceVal.value[j], cityVal.value[k]])
            }
          }
        }
      }
      this.handleClose()
      // list = list.filter(v=>{
      //   return this.tiledlist.some(x=>x.indexOf(v.join('-'))>0)
      // })
      this.$emit('confirm', {
        list: list,
        reverse: this.isReverse
      })
    }

    private handleClose() {
      this.areaNum = []
      this.activeProvice = ''
      this.activeCity = ''
      this.activeArea = ''
      this.currentCityList = null
      this.currentCounty = null
      this.selectCountObj = {}
      this.judgeCheck = {}
      this.$emit('change', false);
    }
  }
